import { render, staticRenderFns } from "./ReviewDocument.vue?vue&type=template&id=aa2aa0b4&"
import script from "./ReviewDocument.vue?vue&type=script&lang=js&"
export * from "./ReviewDocument.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports